import type { RouteObject } from "react-router";

import { ErrorPage } from "@/components/Error/ErrorPage";
import { canAccessProjectRolesAndPermissions } from "@/components/ProjectSidebar/permissions";
import { RequireAuth } from "@/components/Routing/RequireAuth";

import { CreateRolePage } from "./pages/CreateRolePage";
import { EditRolePage } from "./pages/EditRolePage";
import { RoleDetailsPage } from "./pages/RoleDetailsPage";
import { RoleListPage } from "./pages/RoleListPage";
import { canManageRoles } from "./permissions";
import { roleRoutes } from "./routes";

export const rolesRoute = [
  {
    path: roleRoutes.list,
    element: (
      <RequireAuth permission={canAccessProjectRolesAndPermissions}>
        <RoleListPage />
      </RequireAuth>
    ),
  },
  {
    path: roleRoutes.create,
    element: (
      <RequireAuth permission={canManageRoles}>
        <CreateRolePage />
      </RequireAuth>
    ),
  },

  {
    path: roleRoutes.edit,
    element: (
      <RequireAuth permission={canManageRoles}>
        <EditRolePage />
      </RequireAuth>
    ),
  },
  {
    path: roleRoutes.details,
    element: (
      <RequireAuth permission={canManageRoles}>
        <RoleDetailsPage />
      </RequireAuth>
    ),
  },
  { path: "*", element: <ErrorPage status={404} /> },
] satisfies RouteObject[];
